/***** Begin bsLeftNavigation Scripts *****/

var bsLeftNavigation = {

    navigationOffsetValues: [],
    navigationOffset: 0,
    navigationSubnavOffset: 0,
    windowWidth: 0,

    init: function () {
        $('.bsLeftNavigation li').children('span').children('a').click(function (e) { e.preventDefault(); });

        $('.bsLeftNavigation .subnav').each(function () {
            var height = $(this).show().height();
            $(this).hide();

            if (bsLeftNavigation.navigationSubnavOffset < height) {
                bsLeftNavigation.navigationSubnavOffset = height;
            }
        });
       
        $('.bsLeftNavigation li:has(span)').addClass('expandable').on("click", bsLeftNavigation.toggleNavItem).children('a:not(.getQuoteLink,.loginLink,openRegisterModal,openLinkModal,.openToolsModal)').click(function (e) { e.stopPropagation(); });


        if ($('.subnav').children('.active').parent().length > 0) {
            bsLeftNavigation.expandMenu($('.subnav').children('.active').parent().parent());
        }



        $(window).on('resize', function () {

            // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
            if ($(window).width() != bsLeftNavigation.windowWidth) {

                bsLeftNavigation.windowWidth = $(window).width();

                if (this.resizeTO) {
                    clearTimeout(this.resizeTO);
                }

                this.resizeTO = setTimeout(function () {
                    $(".bsLeftNavigation").closest(".pageSection").css("position", "");

                    if ($('.bsLeftNavigation nav .glyphicon-title').css('display') === 'block' || $('nav .glyphicon-title').css('display') === 'inline-block') {
                        bsLeftNavigation.collapseMenu($('.bsLeftNavigation nav .title'));
                    }
                    else {
                        bsLeftNavigation.expandMenu($('.bsLeftNavigation nav .title'));
                    }
                    $('.bsLeftNavigation glyphicon glyphicon-title').children('.glyphicon-minus').removeClass('glyphicon-minus').addClass('glyphicon-plus');
                }, 250);

            }
        });
    },

    toggleNavItem: function () {
        if (($(this).hasClass('title') && (($('nav .glyphicon-title').css('display') === 'block') || ($('nav .glyphicon-title').css('display') === 'inline-block'))) || (!$(this).hasClass('title'))) {
            $(this).siblings().not(".title").children('.glyphicon-minus').removeClass('glyphicon-minus').addClass('glyphicon-plus');
            $(this).siblings().not(".title").children('.subnav').slideUp(500);
        }

        if ($(this).children('.glyphicon-plus').length > 0) {
            bsLeftNavigation.expandMenu($(this));
        }
        else {
            bsLeftNavigation.collapseMenu($(this));
        }

        //$(".bsLeftNavigation").closest(".pageSection").trigger('scroll');
    },

    expandMenu: function (item) {
        item.children('.glyphicon-plus').removeClass('glyphicon-plus').addClass('glyphicon-minus');

        if (item.hasClass('title')) {
            item.siblings().slideDown(500);
        }
        else {
            item.children('.subnav').slideDown(500);
        }
    },

    collapseMenu: function (item) {
        item.children('.glyphicon-minus').removeClass('glyphicon-minus').addClass('glyphicon-plus');

        if (item.hasClass('title') && (($('nav .glyphicon-title').css('display') === 'block') || ($('nav .glyphicon-title').css('display') === 'inline-block'))) {
            item.siblings().slideUp(500);
        }
        else if (!item.hasClass('title')) {
            item.children('.subnav').slideUp(500);
        }
    }

};

/***** End bsLeftNavigation Scripts *****/